import http from '../http'

// 获取项目类型
export const getProjectType = data => {
    return http('/app-api/app/inspection-prj/config-columns-list', 'get', data)
}

// 获取项目类型
export const getProjectTypeShow = data => {
  return http(`/app-api/app/inspection-prj/config-columns-list?show=${true}`, 'get', data)
}


// 获取项目列表
export const getProjectList = data => {
  // return http(`/app-api/app/inspection-prj/page-project?corporateId=${data.corporateId}&pageNo=${data.pageNo}&pageSize=${data.pageSize}&prjConfigId=` + data.prjConfigId +'&queryStr=' + data.queryStr, 'get', data)
  return http(`/app-api/app/inspection-prj/page-project?pageNo=${data.pageNo}&pageSize=${data.pageSize}&prjConfigId=` + data.prjConfigId +'&queryStr=' + data.queryStr, 'get', data)
}
// 设备搜索项目用的
export const getProjectListForEqu = data => {
  return http(`/app-api/app/inspection-prj/all?pageNo=${data.pageNo}&pageSize=${data.pageSize}` +'&queryStr=' + data.queryStr, 'get', data)
}
//  项目详情

export const getprojectinfo = data => {
  return http(`/app-api/app/inspection-prj/get-project?id=${data.id}`, 'get', data)
}

// 添加项目
export const addProject = data => {
  return http('/app-api/app/inspection-prj/create-project', 'post', data)
}

// 修改项目
export const updateProject = data => {
  return http('/app-api/app/inspection-prj/update-project', 'put', data)
}
// 项目下拉选项
export const getProjectSelect = data => {
  return http('/admin-api/inspection/prj-manage/list-all-simple?filedName=' + data.filedName + '&prjConfigId=' + data.prjConfigId, 'get', data)
}
//




// 获取单位类型
export const getEnterpriseType = data => {
  return http('/app-api/app/inspection-uni/config-columns-list', 'get', data)
}


// 获取单位类型
export const getEnterpriseTypeShow = data => {
  return http(`/app-api/app/inspection-uni/config-columns-list?show=${true}`, 'get', data)
}

// 获取单位列表
export const getEnterpriseList = data => {
  return http(`/app-api/app/inspection-uni/page-unit?pageNo=${data.pageNo}&pageSize=${data.pageSize}&uniConfigId=` + data.uniConfigId +'&queryStr=' + data.queryStr, 'get', data)
}
// 搜索单位列表
export const getEnterpriseListForUnit = data => {
  return http(`/app-api/app/inspection-uni/all?pageNo=${data.pageNo}&pageSize=${data.pageSize}` +'&queryStr=' + data.queryStr, 'get', data)
}
// 修改单位
export const updateEnterprise = data => {
  return http('/app-api/app/inspection-uni/update-unit', 'put', data)
}
// 添加单位
export const addEnterprise = data => {
  return http('/app-api/app/inspection-uni/create-unit', 'post', data)
}

//获取单位详细信息
export const getEnterpriseUnit = data => {
  return http('/app-api/app/inspection-uni/get-unit?id=' + data.id, 'get', data)
}
// 单位下拉选项
// export const getUnitSelect = data => {
//   return http('/app-api/app/inspection-uni/list-all-simple?filedName=' + data.filedName + '&uniConfigId=' + data.uniConfigId, 'get', data)
// }



// 获取设备类型
export const getFacilityType = data => {
  return http('/app-api/app/inspection-equ/config-columns-list', 'get', data)
}

// 获取设备类型
export const getFacilityTypeShow = data => {
  return http(`/app-api/app/inspection-equ/config-columns-list?show=${true}`, 'get', data)
}


// 获取设备列表
export const getFacilityList = data => {
  // return http(`/app-api/app/inspection-equ/page-equipment?corporateId=${data.corporateId}&pageNo=${data.pageNo}&pageSize=${data.pageSize}&equConfigId=` + data.equConfigId +'&queryStr=' + data.queryStr, 'get', data)
  return http(`/app-api/app/inspection-equ/page-equipment?pageNo=${data.pageNo}&pageSize=${data.pageSize}&equConfigId=` + data.equConfigId +'&queryStr=' + data.queryStr, 'get', data)
}

// 获取设备列表
export const getFacilityListCorporate = data => {
  // return http(`/app-api/app/inspection-equ/page-equipment?corporateId=${data.corporateId}&pageNo=${data.pageNo}&pageSize=${data.pageSize}&equConfigId=` + data.equConfigId +'&queryStr=' + data.queryStr, 'get', data)
  return http(`/app-api/app/inspection-equ/page-equipment-corporate?pageNo=${data.pageNo}&pageSize=${data.pageSize}&equConfigId=` + data.equConfigId +'&queryStr=' + data.queryStr, 'get', data)
}


//修改设备
export const updateFacility = data => {
  return http('/app-api/app/inspection-equ/update-equipment', 'put', data)
}

// 添加设备
export const addFacility = data => {
  return http('/app-api/app/inspection-equ/create-equipment', 'post', data)
}

// 获取设备详情
export const getFacilityDetailId = data => {
  return http('/app-api/app/inspection-equ/get-equipment?id=' + data.id, 'get', data)
}

export const getFacilityInfo = data => {
  return http(`/app-api/app/inspection-equ/get-equipment?id=${data.id}`, 'get', data)
}

// 通用下拉列表（单位 设备 项目）
export const getSelectUrl = data => {
  return http(data.url, 'get')
}

//设备获取图片
export const getList = data => {
  return http(`/app-api/app/inspection-equ-file/page`, 'get', data,true)
}


//设备上传图片
export const UPcreateList = data => {
  return http(`/app-api/app/inspection-equ-file/create`, 'post', data)
}


//设备删除图片
export const picturedelete = data => {
  return http(`/app-api/app/inspection-equ-file/delete`, 'delete', data,true)
}







